module.exports = __webpack_public_path__ + "static/media/portfolio-4.457db001.jpg";